import LazyImage from '@/components/basic/image';
import theme from '@/style';
import React from 'react';
import {useTranslation} from 'react-i18next';

const copyIcon = require('@components/assets/icons/bets/copy.webp');

type DomStyle = React.CSSProperties | React.CSSProperties[];

export interface DrawStatusProps {
  colors?: string[];
  textColor?: string;
  label?: string;
  id?: string;
  tip?: string;
  onCopy?: () => void;
  isDetail?: boolean;
  style?: DomStyle;
}

const flattenStyle = (style?: DomStyle): React.CSSProperties =>
  Array.isArray(style) ? Object.assign({}, ...style) : style || {};

const gradient = (colors: string[], reverse: boolean) => {
  const safeColors = colors.length ? colors : ['transparent', 'transparent'];
  return `linear-gradient(${reverse ? 270 : 90}deg, ${safeColors.join(', ')})`;
};

const DrawStatus = ({
  colors = [],
  textColor = '',
  label = '',
  id = '',
  isDetail = false,
  tip = '',
  style,
  onCopy = () => {},
}: DrawStatusProps) => {
  const {i18n} = useTranslation();

  return (
    <div
      className={`flex items-center justify-between rounded-[1.25rem] px-3 py-1.5 ${
        isDetail ? 'flex-row' : 'flex-row-reverse'
      }`}
      style={{
        background: gradient(colors, !isDetail),
        ...flattenStyle(style),
      }}>
      <div
        className={`min-w-0 flex-1 ${isDetail ? 'text-left' : 'text-right'}`}>
        <span
          className="block truncate text-sm font-medium"
          style={{color: textColor}}>
          {label}
        </span>
      </div>
      {isDetail ? (
        <div className="flex items-center">
          <span
            className="mr-1 text-sm"
            style={{color: theme.fontColor.accent}}>
            {i18n.t('label.id')}
          </span>
          <span className="text-sm" style={{color: theme.fontColor.second}}>
            {id}
          </span>
          <button
            type="button"
            onClick={onCopy}
            className="ml-1 border-0 bg-transparent p-0">
            <LazyImage
              imageUrl={copyIcon}
              width={14}
              height={14}
              occupancy="transparent"
            />
          </button>
        </div>
      ) : (
        <span
          className="mr-2 text-xs font-medium"
          style={{color: theme.basicColor.dark}}>
          {tip}
        </span>
      )}
    </div>
  );
};

export default DrawStatus;
